import formatAmount from '@shared/utils/formatAmount';
import { EMPTY } from '@shared/utils/strings';
export default function formatOptionalCentsAmountWith2Precision(amount, defaultString = EMPTY, symbol = false) {
    return amount === null || amount === undefined
        ? defaultString
        : formatAmount(amount / 100, true, symbol);
}
